module.exports = __webpack_public_path__ + "static/media/zm.b7864d5c.svg";